/**
 * Pack illustrations.
 *
 * ChiCare does not own photography for 2,400 drugs and never will. Buyers still
 * need to tell a syrup from a blister from a BP monitor at a glance on a 393px
 * screen, so the design system draws them: isometric boxes in the same blue-and-
 * paper palette as everything else, with a coloured band that differs per form.
 *
 * Ported verbatim from the `<symbol id="pk-*">` set in ChiCare-Mockups/. The
 * server picks the key (`Product::packArtKey()`), so web and mobile always draw
 * the same box for the same drug without either client guessing.
 */

import type { PackArtKey } from '@chicare/shared';
import { cn } from '@/lib/cn';
import { packArtPaths } from './packArtPaths';


export interface PackArtProps {
  name: PackArtKey;
  className?: string;
  /** Describe the product for screen readers, or leave decorative. */
  title?: string;
}

export function PackArt({ name, className, title }: PackArtProps) {
  return (
    <svg
      viewBox="0 0 100 100"
      className={cn('h-full w-full', className)}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      {title ? <title>{title}</title> : null}
      {packArtPaths[name] ?? packArtPaths.para}
    </svg>
  );
}
